// extracted by mini-css-extract-plugin
export default {"confirmModal":"O8J58hiD","heading":"CtsprYl1","controls":"Ksyu4r_U"};